export const SIGNATURE_REQUEST_ORDER_BY_CREATED_AT = "CREATED_AT";
export const SIGNATURE_REQUEST_ORDER_BY_DOCUMENTS = "DOCUMENTS";
export const SIGNATURE_REQUEST_ORDER_BY_DRAFT = "DRAFT";
export const SIGNATURE_REQUEST_ORDER_BY_ID = "ID";
export const SIGNATURE_REQUEST_ORDER_BY_INITIATOR_ID = "INITIATOR_ID";
export const SIGNATURE_REQUEST_ORDER_BY_STATUS = "STATUS";
export const SIGNATURE_REQUEST_ORDER_BY_UPDATED_AT = "UPDATED_AT";
